(function (global) {
  'use strict';

  const VERSION = 2;
  const STORAGE_KEY = 'bbc-diaper-dash-preferences-v2';
  const PARTNER_IDS = Object.freeze(['1', '2', '3', '4', '5']);
  const MAX_NAME_LENGTH = 20;

  const defaults = () => ({
    version: VERSION,
    selectedPartnerId: '1',
    names: {},
    soundEffectsEnabled: true,
    voiceReactionsEnabled: true
  });

  function nameParts(value) {
    const cleaned = String(value).normalize('NFC').replace(/[\u0000-\u001f\u007f-\u009f]/g, ' ');
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
      return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(cleaned), part => part.segment);
    }
    return Array.from(cleaned);
  }

  const limitNameInput = value => {
    const output = [];
    let codePoints = 0;
    for (const part of nameParts(typeof value === 'string' ? value : '')) {
      const partLength = Array.from(part).length;
      if (output.length >= MAX_NAME_LENGTH || codePoints + partLength > MAX_NAME_LENGTH) break;
      output.push(part);
      codePoints += partLength;
    }
    return output.join('');
  };
  const normalizeName = value => limitNameInput(value).trim();

  function normalizePreferences(value) {
    const result = defaults();
    if (!value || typeof value !== 'object' || Array.isArray(value)) return result;
    if (PARTNER_IDS.includes(String(value.selectedPartnerId))) result.selectedPartnerId = String(value.selectedPartnerId);
    if (value.names && typeof value.names === 'object' && !Array.isArray(value.names)) {
      for (const id of PARTNER_IDS) {
        if (typeof value.names[id] !== 'string') continue;
        const name = normalizeName(value.names[id]);
        if (name) result.names[id] = name;
      }
    }
    if (typeof value.soundEffectsEnabled === 'boolean') result.soundEffectsEnabled = value.soundEffectsEnabled;
    if (typeof value.voiceReactionsEnabled === 'boolean') result.voiceReactionsEnabled = value.voiceReactionsEnabled;
    return result;
  }

  function readPreferences(storage, legacyScope = 'guest') {
    try {
      const current = storage?.getItem(STORAGE_KEY);
      if (current) {
        const parsed = JSON.parse(current);
        if (parsed?.version === VERSION && parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          return { preferences: normalizePreferences(parsed), source: 'v2' };
        }
      }
    } catch {}
    try {
      const legacy = storage?.getItem(`bbc-diaper-dash-settings-v1:${legacyScope}`);
      if (legacy) {
        const parsed = JSON.parse(legacy);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          const partner = PARTNER_IDS.includes(String(parsed.partner)) ? String(parsed.partner) : '1';
          const name = normalizeName(parsed.name);
          return {
            preferences: normalizePreferences({
              selectedPartnerId: partner,
              names: name ? { [partner]: name } : {},
              soundEffectsEnabled: parsed.sound !== false,
              voiceReactionsEnabled: parsed.voice !== false
            }),
            source: 'legacy'
          };
        }
      }
    } catch {}
    return { preferences: defaults(), source: 'default' };
  }

  function savePreferences(storage, preferences) {
    try {
      storage?.setItem(STORAGE_KEY, JSON.stringify(normalizePreferences(preferences)));
      return Boolean(storage);
    } catch { return false; }
  }

  function chooseReaction(lines, previous = '', random = Math.random) {
    const available = Array.isArray(lines) ? lines.filter(line => typeof line === 'string' && line.trim()) : [];
    if (!available.length) return '';
    const choices = available.length > 1 ? available.filter(line => line !== previous) : available;
    const pool = choices.length ? choices : available;
    const roll = Number(random());
    const index = Math.min(pool.length - 1, Math.max(0, Math.floor((Number.isFinite(roll) ? roll : 0) * pool.length)));
    return pool[index];
  }

  const api = Object.freeze({ VERSION, STORAGE_KEY, PARTNER_IDS, MAX_NAME_LENGTH, defaults, limitNameInput, normalizeName, normalizePreferences, readPreferences, savePreferences, chooseReaction });
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (global) global.BBC_DIAPER_DASH_PERSONALISATION = api;
})(typeof window !== 'undefined' ? window : null);
